import { fetchToken } from "../../common/FetchCookie";
import { BASE_URL, CANDIDATE, COMPANY_REVIEW_LIST, COMPANY_REVIEW_SAVE, PUBLIC } from "../../common/URLs";

const API_BASE_URL = `${BASE_URL}/${PUBLIC}/${COMPANY_REVIEW_LIST}`

export const fetchPublicCompanyReviews = async (uuid) => {
  const url = `${API_BASE_URL}/${uuid}?perPageCount=5`; // Proxy path
  try {
    const token = await fetchToken()
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("response", response)
    const data = await response.json();
    return data;
  } catch (error) {
    console.log("error", error);
  }
};


// candidate side
export const addCompanyReview = async (newCompanyReview) => {
  const url = `${BASE_URL}/${CANDIDATE}/${COMPANY_REVIEW_SAVE}`; // Proxy path
  try {
    const token = await fetchToken()

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newCompanyReview),
    });
    const data = await response.json(); 
    // console.log("API Data", data);
    return data;
  } catch (error) {
    console.log("error", error);
    throw error;
  }
};